import { Badge } from "antd"
import { Space } from "antd"

interface IHeaderWithPeriodBadge {
  headerText: string
  period?: string
}

const HeaderWithPeriodBadge: React.FC<IHeaderWithPeriodBadge> = ({
  headerText,
  period = "4WK",
}) => {
  return (
    <Space>
      {headerText}
      <Badge count={period} color="#b8b6b4" />
    </Space>
  )
}

export default HeaderWithPeriodBadge
